import React from "react";
import { Link } from "react-router-dom";

function AtlasCardItinerary(props) {
    const { title, days, stops, distance, id, travelType } = props;
    return (
        <Link target="_blank" to={`/?id=${id}`} className="trpr-atlas-card-itinerary">
            <span className="trpr-atlas-card-itinerary__title">{title}</span>
            <div className="trpr-atlas-card-itinerary__data">
                <ul>
                    <li>{days} days</li>
                    <li>{stops} stops</li>
                    <li>{distance} km</li>
                </ul>
                <span className="trpr-atlas-card-itinerary__link">
                    <span>Open in new tab</span>
                    <i className="trpr__icon-arrow-right"></i>
                </span>
            </div>
            {travelType && <span className="trpr-atlas-card-itinerary__tag">{travelType}</span>}
        </Link>
    );
}

AtlasCardItinerary.defaultProps = {
    distance: 0,
    days: 0,
};

export default AtlasCardItinerary;
